<template>
    <div class="regist">
        <div class="login-header">
            <div class="login-brand">
                <img :src="logoImg" class="logo"/>
            </div>
        </div>
        <div class="resigt_cent">
            <h1 class="role">忘记密码</h1>

			<el-steps style="margin-top: 100px;" :active="active" align-center finish-status="success">
			  <el-step title="填写账号"></el-step>
			  <el-step title="验证并设置新密码"></el-step>
			  <el-step title="设置成功"></el-step>
			</el-steps>
            <div class="resigt_from" style="padding: 0;">
                <el-form :rules="dataRule" ref="form" status-icon :model="dataForm">
					<h3 v-if="active == 0" style="margin: 0;text-align: center;font-size: 16px;margin-top: 40px;color: #333;line-height: 90px;font-weight: 400;">输入您忘记密码的账号信息：</h3>
                    <h3 v-if="active == 1" style="margin: 0;text-align: center;font-size: 16px;margin-top: 40px;color: #333;line-height: 90px;font-weight: 400;">请输入您新的密码：</h3>
                    <h3 v-if="active == 2" style="margin: 0;text-align: center;font-size: 16px;margin-top: 40px;color: #333;line-height: 90px;font-weight: 400;">恭喜您，设置新密码成功</h3>

					<el-form-item prop="username" label="" v-if="active == 0">
                        <el-input v-model="dataForm.username" placeholder="请输入账号" autocomplete="off"></el-input>
                        <!-- <el-input style="position: fixed;bottom: -9999px;"></el-input> -->
                    </el-form-item>
					<el-form-item>
						<el-button type="primary" v-if="active == 0" @click="next()" style="width: 400px;height: 80px;line-height: 80px;font-size: 20px;border-radius: 40px!important;">下一步</el-button>
					</el-form-item>
					<el-form-item prop="code" label="" v-if="active == 1">
						<el-input class="codeInput" style="width: 247px;margin-right: 15px;" placeholder="请输入验证码" v-model="dataForm.code"></el-input>
						<el-button type="info" style="width: 128px;height: 70px;line-height: 70px;border-radius: 14px;padding: 0;" @click="sendCode" v-show="isShow">发送验证码</el-button>
						<el-button type="info" :disabled="false" v-show="!isShow" style="padding: 0;width: 128px;height: 70px;line-height: 70px;border-radius: 14px;background-color: lightgrey">{{secondsCount}}秒后重发</el-button>
					</el-form-item>
					<el-form-item prop="password" label="" v-if="active == 1">
					    <el-input type="password" v-model="dataForm.password" placeholder="输入您的密码"
					              autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" v-if="active == 1" @click="dataFormSubmit('form')" style="width: 400px;height: 80px;line-height: 80px;font-size: 20px;border-radius: 40px!important;">下一步</el-button>
					</el-form-item>
					<el-form-item v-if="active == 2" style="text-align: center;margin-bottom: 20px;">
					    <img src="../../assets/img/setpwd.png" style="width: 180px;height: 180px;"/>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" v-if="active == 2" @click="$router.replace({name: 'login'})" style="width: 400px;height: 80px;line-height: 80px;font-size: 20px;border-radius: 40px!important;">完成</el-button>
					</el-form-item>

                </el-form>
            </div>
        </div>
        <div class="login-footer">
            <p>Copyright 2010-2019 财天下科技有限公司 版权所有 <a href="https://beian.miit.gov.cn" style="color: #939393" >京ICP备20006561号-1</a></p>
        </div>

    </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { isMobile,testPassword } from '@/utils/validate'
import aesJs from '../../utils/login-aes'

export default {
  data () {
    return {
      active: 0,
      userPhone: '',
      secondsCount: 0, // 倒计秒数初始化定义
      isShow: true, // 是否显示发送验证码按钮
      logoImg: require('../../assets/img/logo.png'), // icon
      dataForm: {
        username: '',
        password: '',
        optionCheck: [],
        code: ''
      },
      dialogVisible: false
    }
  },

  computed: {
    dataRule () {
      var checkpassword = (rule, value, callback) => {
        if(testPassword(value)){
          callback()
        }else{
          callback(new Error('请输入密码'))
        }
        // if (/^[A-Za-z0-9]{8,15}$/.test(value)) {
        //   callback() 8-15位数字或字母密码
        // } else {
        //   callback(new Error('请输入密码'))
        // }
      }
      return {
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { message: '请设置8到12位数字，大写、小写字母，符号，至少三种',validator: checkpassword,trigger: 'blur'}

        ]

      }
    }
  },
  created () {
    console.log(this.$route.query.userType == '1')
    // this.dataForm.userType = this.$route.
  },

  methods: {
    next () {
      if (this.dataForm.username == '') {
				    return this.$message.error('账号不能为空')
      }
      /**
       * 注意166是联通号段，191是电信号段，这些都是新的号段
       */
      // const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
      // if (!reg.test(this.dataForm.mobile)) {
			// 	    return this.$message.error('请输入正确的手机号')
      // }
      this.active++
    },
    sendCode () {
      if (this.dataForm.username == '') {
                	return this.$message.error('账号不能为空')
      }
      // const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
      // if (!reg.test(this.dataForm.mobile)) {
      //           	return this.$message.error('请输入正确的手机号')
      // } else {
        // 发送短信验证
        this.$http.post('/sys/forget-pwd/send-code', { 
              // mobile: this.dataForm.mobile 
              username:this.dataForm.username,
              from:'pc'
            }, {
                		headers: {
                			'content-type': 'application/json;charset=UTF-8'
                		}
                	}).then(res => {
          // 倒计时
                		if (res.data.code == 0) {
                			let that = this
                			console.log(that)
                			that.secondsCount = 60
                			// 切换倒计时按钮
                			that.isShow = false
                			// 倒计时函数
                			let timer = setInterval(function () {
                			    that.secondsCount--
                			    if (that.secondsCount <= 0) {
                			        clearInterval(timer)
                			        that.isShow = true
                			    }
                			}, 1000)
                		} else {
                			this.$message.error(res.data.msg)
                		}
        })
      // }
    },
    // 表单提交
    dataFormSubmit: debounce(function (dataForm) {
      this.$refs[dataForm].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dataForm.password = aesJs.encrypt(this.dataForm.password)
        this.$http.post('/sys/forget-pwd/update-pwd',
          this.dataForm,
          { headers: {
            'content-type': 'application/json;charset=UTF-8'
          } }).then(({ data: res }) => {
            this.dataForm.password = aesJs.decrypt(this.dataForm.password)
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          if (res.msg === 'success') {
            this.$message({
              message: '重置成功',
              type: 'success',
              duration: 1000
            })
            this.active++
            // this.$router.replace({name: 'login'})
          }
        }).catch(() => {
        })
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style scoped lang='scss'>
    .regist {
        width: 100%;
        height: 100vh;
        margin: 0 auto;
        background: #F3F4F5;
        overflow-y: auto;
    }

    .regist .login-header {
        width: 100%;
        height: 100px;
        background: #fff;
        position: relative;
    }

    .regist .login-header .login-brand {
        width: 1200px;
        position: absolute;
        left: 50%;
        margin-left: -600px;
    }

    .logo {
        width: 200px;
        margin-top: 26px;
    }

    .login-footer {
        width: 460px;
		margin-left: 710px;
        padding: 10px;
        color: #666666;
		font-size: 12px;
        p {
            height: 16px;
            margin: 10px 0;
            text-align: center;
        }
    }

    .role {
        line-height: 86px;
		margin: 0;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
		text-align: center;
		border-bottom: 2px solid #d9d9da;
    }

    .resigt_cent {
        width: 1200px;
		height: 770px;
        margin: 30px auto 10px;
        background: #fff;
        overflow: hidden;
        clear: both;
    }

    .resigt_from {
        display: flex;
        justify-content: center;
        padding: 70px 40px;
        box-sizing: border-box;
    }

    .resigt_from .el-form-item {
        flex: 1;
    }

    .regBtn {
        background: linear-gradient(90deg, rgba(87, 156, 255, 1) 0%, rgba(51, 114, 242, 1) 100%);
        box-shadow: 0px 6px 9px 0px rgba(26, 57, 179, 0.32);
        border-radius: 40px;
    }
</style>
<style>
	.resigt_from input{
		width: 390px;
		height: 70px;
		border: none;
		border-radius: 14px;
		background-color: #f8f8f8;
		line-height: 70px;
	}
	.codeInput input{
		width: 247px;
	}
	.resigt_from .el-checkbox__input.is-checked+.el-checkbox__label{
		color: #409eff;
	}
	.el-step__title.is-process{
		color: #409eff;
	}
	.el-step__icon{
		border: none!important;
	}
	.el-step__head.is-process .el-step__icon{
		background-color: #409eff;
		color: #fff;
	}
	.el-step__head.is-wait .el-step__icon{
		background-color: #C0C3C3;
		color: #fff;
	}
	.el-step__head.is-success .el-step__icon{
		background-color: #43B743;
		color: #fff;
	}
</style>
